import script from "./FreeTrial.vue?vue&type=script&setup=true&lang=js"
export * from "./FreeTrial.vue?vue&type=script&setup=true&lang=js"

import "./FreeTrial.vue?vue&type=style&index=0&id=9bb538b0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9bb538b0"]])

export default __exports__